import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
const CategoryItem = ({ category, editData }) => (_jsx(Link, { component: RouterLink, underline: "none", to: `cat/${category.slug || category.id}`, className: "pageMenu", onClick: (ev) => editData && editData.preNavigationHook(`cat/${category.slug || category.id}`, ev), sx: {
        typography: 'subtitle1',
        letterSpacing: 'normal',
        justifyContent: { xs: 'end', sm: 'start' },
        p: { xs: '6px 15px' },
        borderRadius: '5px',
        padding: '6px 8px',
        '&:hover': { background: (theme) => theme.palette.backgroundLightHover },
        color: 'site.pageMenus.color',
        fontWeight: 'site.pageMenus.fontWeight',
        fontSize: 'site.pageMenus.fontWeight',
        textTransform: 'site.pageMenus.textTransform',
        backgroundColor: 'site.pageMenus.backgroundColor',
        borderColor: 'site.pageMenus.borderColor',
    }, children: category.name }, category.id));
export default CategoryItem;
//# sourceMappingURL=CategoryItem.js.map